export function hasSlot(vm, name = 'default') {
    const scopedSlots = vm['$scoped' + 'Slots']
    const slots = vm.$slots

    return !!((scopedSlots && scopedSlots[name]) || (slots && slots[name]))
}
